import { Component, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { Newsletter } from '../../../shared/interface';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-newsletter-backoffice',
  templateUrl: './newsletter-backoffice.component.html',
  styleUrl: './newsletter-backoffice.component.css'
})
export class NewsletterBackofficeComponent {

  constructor(private apiService: ApiService, private confirmationService: ConfirmationService, private router: Router) { }

  @ViewChild("deleteNewsletter") deleteNewsletter!: ConfirmPopup;

  newsletters: Newsletter[] = [];
  loading: boolean = false;

  ngOnInit(): void {

    this.loading = true;

    this.apiService.setNewsletters();
    this.apiService.newslettersChanged.subscribe({
      next: (data) => {
        this.newsletters = [...data];
        this.loading = false;
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message)      
    })

  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onOpenDeleteNewsletter(event: Event, newsletter: Newsletter) {

    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Sei sicuro di voler eliminare l'email ${newsletter?.email} dalla newsletter?`,
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteNewsletter(newsletter.id).subscribe({
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {

            this.confirmationService.close()
            this.router.navigate(['/backoffice/newsletter']);

            this.apiService.setNewsletters()
            this.apiService.message("success", "Eliminazione", "L'email è stata eliminata con successo")
          }
        })
      }
    });
  }

  onDeleteNewsletter() {
    this.deleteNewsletter.accept();
  }

  onAnnullaDeleteNewsletter() {
    this.deleteNewsletter.reject();
  }

}
